import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-setting-row",
  host: { class: "flex items-center justify-between gap-40" },
  template: `
    <div class="type-body-medium text-foreground inline-flex shrink-0 items-center gap-1 whitespace-nowrap">
      <ng-content select="[label]" />
    </div>
    <ng-content />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingRowComponent {}
